import styled, { css } from 'styled-components';
import { theme } from '../themes';

const Styles = css`
  html {
    box-sizing: border-box;
  }

  body {
    
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }


  button, input {
    line-height: 1;
  }

  em {
    font-style: normal;;
  }

  img{
    max-width: 100%;
    height: auto;
  }


`

export default Styles
